import { Code, IconInvoice } from '~/design-system';
import { getApi } from '~/platform/data/apiSingleton';
import type { ModuleDefinition } from '~/platform/registry/types';

export const invoicesModule: ModuleDefinition = {
  id: 'invoices',
  i18nNamespace: 'invoices',
  requires: { subject: 'invoice', action: 'read' },

  nav: {
    labelKey: 'invoices:nav',
    icon: IconInvoice,
    to: 'invoices',
    group: 'money',
    order: 10,
  },

  routes: [{ path: 'invoices', component: () => import('./InvoicesPage') }],

  commands: [
    {
      id: 'invoices.issue',
      labelKey: 'invoices:issue',
      groupKey: 'invoices:title',
      requires: { subject: 'invoice', action: 'create' },
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/invoices?new=1`),
    },
  ],

  search: async (query, { businessId }) => {
    const invoices = await getApi().listInvoices(businessId, { search: query });
    return invoices.slice(0, 6).map((invoice) => ({
      id: invoice.id,
      moduleId: 'invoices' as const,
      code: invoice.number,
      title: invoice.partyName,
      subtitle: invoice.dueDate,
      handlingClass: invoice.direction === 'sales' ? 'ambient' : 'neutral',
      stamp: <Code>{invoice.status}</Code>,
      to: `/b/${invoice.businessId}/invoices?invoice=${invoice.id}`,
    }));
  },
};
